// extracted by mini-css-extract-plugin
export var actions = "_62-8";
export var arrow = "_62-5";
export var card = "_62-0";
export var cardWrapper = "_62-9";
export var fieldName = "_62-3";
export var newValue = "_62-6";
export var oldValue = "_62-4";
export var orangeGlowFade = "_62-c";
export var productSection = "_62-1";
export var scrollToBottom = "_62-b";
export var scrollToBottomAnchor = "_62-a";
export var scrollToBottomIcon = "_62-d";
export var showAllButton = "_62-7";
export var table = "_62-2";